import { render, staticRenderFns } from "./PageHeaderResult.vue?vue&type=template&id=14f9a246&"
import script from "./PageHeaderResult.vue?vue&type=script&lang=js&"
export * from "./PageHeaderResult.vue?vue&type=script&lang=js&"
import style0 from "./PageHeaderResult.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports